<template>
  <div class="flex flex-col h-screen w-screen overflow-hidden bg-blueGray-100">
    <!-- 상단 영역 (모바일 h-14, 데스크톱 h-20) -->
    <admin-navbar
      class="fixed top-0 left-0 right-0 z-30"
      @toggle-sidebar="sidebarOpen = !sidebarOpen"
    />

    <!-- 본문 영역 (상단 Navbar 모바일 56px, 데스크톱 80px 제외한 전체 영역) -->
    <div class="flex flex-row flex-1 pt-14 xl:pt-20 h-full overflow-hidden relative">
      <!-- 모바일 사이드바 활성화 시 어두운 딤 배경 (클릭 시 닫힘) -->
      <transition
        enter-active-class="transition-opacity duration-200"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="sidebarOpen"
          class="fixed inset-0 bg-black/40 z-30 xl:hidden"
          @click="sidebarOpen = false"
        />
      </transition>

      <!-- 좌측 사이드바 (PC: 인라인, 모바일: 오버레이 드로어) -->
      <sidebar v-model="sidebarOpen" class="flex-shrink-0 h-full" />

      <!-- 우측 메인 영역 -->
      <div class="flex-1 flex flex-col h-full overflow-hidden bg-blueGray-100 min-w-0">
        <!-- 메뉴탭 헤더 -->
        <tab-header class="flex-shrink-0" />

        <!-- 본문 화면 영역 -->
        <div class="flex-1 overflow-x-auto overflow-y-auto px-1 sm:px-2 bg-white">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import AdminNavbar from "@/components/layouts/AdminNavbar.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import TabHeader from "@/components/layouts/TabHeader.vue";

// PC(1280px 이상)에서는 기본 펼침(true), 모바일/가로모드/태블릿(<1280px)에서는 닫힘(false)
const sidebarOpen = ref(window.innerWidth >= 1280);

onMounted(() => {
  const handleResize = () => {
    // 1280px 이상이면 PC 사이드바 활성화, 1280px 미만(모바일/가로모드)에서는 자동 닫힘
    if (window.innerWidth >= 1280) {
      if (!sidebarOpen.value) sidebarOpen.value = true;
    } else {
      if (sidebarOpen.value) sidebarOpen.value = false;
    }
  };
  window.addEventListener("resize", handleResize);
  window.addEventListener("orientationchange", handleResize);
});
</script>
